/*
 * Copyright (C) 2024 Net4Media Services SRL. - All Rights Reserved
 *
 * Soft.Eng. Florin Mihăescu <florinmihaescu96@gmail.com>
 *
 * Unauthorized copying or redistribution of this file in source and binary forms via any medium
 * is strictly prohibited.
 */

window.bootstrap  = require('bootstrap');
window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');
window.select2 = require('select2');
require('datatables.net-bs5');
//window.InteractJS = require('interactjs');

$(document).ready(function () {
    //Offcanvas Bootstrap
    let offcanvasElementList = [].slice.call(document.querySelectorAll('.offcanvas'))
    offcanvasElementList.map(function (offcanvasEl) {
        return new bootstrap.Offcanvas(offcanvasEl)
    });

    //Tooltips Bootstrap
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    });

    //Popovers Bootstrap
    let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    });

    //Ajax Header
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $('.alert').on('click', function () {
        $('.alert').removeClass('show');
    });
    setTimeout(function (){
        $('.alert').removeClass('show');
    }, 30 * 1000);
});

console.log("/*\n" +
    " * NOTICE OF LICENSE.\n" +
    " *\n" +
    " *  The project is closed-source software licensed under the Private License.\n" +
    " *  Unauthorized copying or redistribution of this file in source and binary forms via any medium is strictly prohibited.\n" +
    " *  @Author Sr.Soft.Eng. Trifu Marian <marian.trifu@net4media.net>\n" +
    " *  @Author Soft.Eng. Mihăescu Florin <florinmihaescu96@gmail.com>\n" +
    " *  @License Private License - Net4Media\n" +
    " *\n" +
    " */");
